import { pipe } from "fp-ts/function";
import * as RTE from "fp-ts/ReaderTaskEither";
import * as Json from "@discovery/maestro-json";
export * from "./cancelation-exception";
export * from "./http-exception";
export * from "./request";
export const http = (req, cancelToken) => pipe(RTE.ask(), RTE.chainTaskEitherK((a) => a.http(req, cancelToken)));
export const json = (req, cancelToken) => pipe(http(req, cancelToken), RTE.chainW((res) => Json.fromString(res.body)));

